<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="automationId" primaryButtonLabel="Export"
    (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="okEnabled()" secondaryButtonLabel="Cancel"
    (closeButtonActionEmt)="closeModal()" [modalHelpIndex]="modalHelpIndex" [modalClass]="modalClass"
    [(isBusy)]="isBusy" [(isBusyMessage)]="isBusyMessage">
    <res-custom-radio-button [automationId]="automationId + '-produce-duplicate-files'"
        [(ngModel)]="produceDuplicateFiles" content="Produce Duplicate Files" name="exportDuplicateMode" [value]="true">
    </res-custom-radio-button>
    <res-custom-radio-button
        [automationId]="automationId + '-produce-a-load-file-that-references-duplicate-source-files'"
        [(ngModel)]="produceDuplicateFiles" content="Produce a Load File that references Duplicate Source Files"
        name="exportDuplicateMode" [value]="false">
    </res-custom-radio-button>
</res-base-modal>